
(function ($) {
  $(document).ready(function () {
    const checkout_price_onepay = window.theme.checkout_price_onepay;
    const show_checkout_price_onepay = window.theme.show_checkout_price_onepay;

    const checkout_price_payoo = window.theme.checkout_price_payoo;
    const disable_installment_payoo_mode = window.theme.disable_installment_payoo_mode;

    const config_product_sixd = window.theme.config_product_sixd;
    const config_exclusion_based_on_8d = window.theme.config_exclusion_based_on_8d;
    const label_zero_installment = window.theme.label_zero_installment;
    const label_coming_soon = window.theme.label_coming_soon;
    const label_free_installation = window.theme.label_free_installation;
    const label_sold_out = window.theme.label_sold_out;
    const label_add_to_cart = window.theme.label_add_to_cart;
    const label_pre_order = window.theme.label_pre_order;
    var zero_installment_products = "6873958481979,6873958350907,6873958187067,6873958318139,6873958088763,6535374995515,6939368587323,6906029867067,6906030424123,6906042417211,6906049265723,6907663155259,6907662729275,6907661942843,6907661516859,6907661254715,6907660730427,6906182828091,6999521853499,7005899325499,7005895917627,7005898080315,7005898604603,7005879107643,7005894475835,7032963956795,7032964317243,7032963530811,7038367432763,7038370381883,7038371594299,7038372216891,7038372806715,7032964120635,7038374477883,7038373855291,6621033693243,6785165295675,7056277045307,7092064976955,7092065370171,7092065206331,7086174863419,7243760468027,7243761877051";
    var free_installment_products = "6865696030779,6873757450299,6865696194619,6865696358459,7005894475835,7005899325499,7005895917627,7005898080315,7005898604603,7005879107643,7245817086011,7233699119163,7233710653499,7233749811259,6902770565179,7233763639355,6865696030779,7233654849595,6920540651579,7160968085563,7310335180859,7261422878779,40123580055611,40123579793467";

    showListProduct();

    function showListProduct() {
      if ($('.static-product-page').length > 0) {
        let listCollectionProduct = $('.static-product-page .collection');
        listCollectionProduct.map(function (i, ele) {
          let collectionID = $(ele).data('collection');
          $(ele).addClass('loader');
          callAPIGetCollection(collectionID, ele).then(function (result) {
            $(ele).removeClass('loader');
            showProduct(result, ele);
          });
        });
      };
    }

    function callAPIGetCollection(collectionID) {
      let promiseObj = new Promise(function (resolve, reject) {
        callAPIWithTokenRefresh(`collections/${collectionID}/products`, 'get')
          .then(function (res) {
            resolve(res);
          }).catch(function (res) {
            reject([]);
          });
      });
      return promiseObj;
    }

    function showProduct(data, ele) {
      if (data) {
        if (data.status) {
          let html_product = `
          <section class="section"><div class="container"><div class="list-products grid grid--large">`;
          for (let i = 0; i < data.data.length; i++) {
            let item = data.data[i];
            let variants = item.variants;
            let variant = item.variants[0], discount_html = '', old_price = '';

            if(variant) {
              if (variant.compare_at_price) {
                let discount = (variant.compare_at_price - variant.price) / variant.compare_at_price * 100;
                discount = Math.round(discount);
                if (discount) {
                  discount_html = ` <div class="discount"><span>Giảm giá</span><span>${discount}%</span></div>`;
                }
                old_price = Shopify.formatMoney(variant.compare_at_price * 100, window.myprice);
              }
              let image = item.image != undefined ? item.image.src : '';
  
              var _tag = item.tags, _res = _tag.split(","), list_label = "", new_tag='';
              let price_main = variant.price;
              let has_zero_installment = false;
              let has_zero_installment_text = label_zero_installment;

              const onepayInstallmentEnabled = price_main >= parseInt(checkout_price_onepay) && show_checkout_price_onepay;
              const payooInstallmentEnabled = price_main >= parseInt(checkout_price_payoo) && disable_installment_payoo_mode;
              
              if ((onepayInstallmentEnabled || payooInstallmentEnabled) && (zero_installment_products.indexOf(item.id) < 0)) {
                has_zero_installment = true;
              }
              if (has_zero_installment) {
                list_label += '<span class="label label--custom zero_installment_label">' + has_zero_installment_text + '</span>';
              }
              let has_config_exclusion_based_on_8d = false;
              let has_config_product_sixd = false;
              let _model = '';
              // default is_out_of_stock is TRUE
              let is_out_of_stock = true;
              let is_coming_soon = false;
              let is_pre_order = false;
              for (_i = 0; _i < _res.length; _i++) {
                // Product model tag
                if (_res[_i].includes("__model")) {
                  _model = _res[_i].replace('__model:', '');
                };
  
                // Product label custom tag
                var _label = _res[_i].includes("__label");
  
                if (_label) {
                  var label_class = _res[_i].replace('__label:', '');
                  label_class = label_class.trim();
                  label_class = label_class.replace(new RegExp(' ', 'g'), '_') + "_label";
                  label_class = label_class.toLowerCase();
                  let label_name = _res[_i].replace('__label:', '');
                  let label_name_lower = label_name.trim().toLowerCase();
                  const product_setting_tags = (
                    "new,sản phẩm mới,Độc quyền,HOT"
                  )?.split(',')?.map((tag) => tag?.trim()?.toLowerCase());
                  const new_product_labels_list = ['new', 'sản phẩm mới'];

                  if (label_name_lower == "pre order" || label_name_lower == "đặt hàng trước" || label_name_lower == "combo mới") {
                    is_pre_order = true;
                    setTimeout(() => {
                      $(this).find('.product__add-to-cart').text(label_name);
                    }, 1000);
                  }
  
                  if (label_name_lower == "hàng sắp về" || label_name_lower == "coming soon") {
                    setTimeout(() => {
                      $(this).find('.product__add-to-cart').text(label_name).attr('disabled', 'disabled');
                    }, 1000);
                    label_name = label_coming_soon;
                    is_coming_soon = true;
                  }

                  if(label_name_lower === 'pre order' || label_name_lower === 'đặt hàng trước') {
                    label_name = 'Đặt trước';
                  }

                  if(!new_product_labels_list.includes(label_name_lower)) {
                    if(!product_setting_tags.includes(label_name_lower)) {
                      list_label += '<span class="label label--custom ' + label_class + '">' + label_name + '</span>';
                    }
                  }
                  else {
                    const product_tags_list = [];
                    if (new_product_labels_list.includes(label_name_lower)) {
                      product_tags_list.push(label_name_lower);
                    }
                    if (product_setting_tags.length) {
                      product_setting_tags.forEach((tag) => {
                        if (_res.find((item) => item.toLowerCase().includes('__label') && item.toLowerCase()
                          .includes(tag)) && !new_product_labels_list.includes(tag) && !product_tags_list.includes(
                          tag)) {
                          product_tags_list.push(tag);
                        }
                      });
                    }
                    
                    if (product_tags_list.length) {
                      for (const tag of product_tags_list) {
                        if (new_product_labels_list.includes(tag)) {
                          label_name += `
                               <span class='label sản_phẩm_mới_label'>
                                mới
                               </span><br/>
                             `;
                        } else {
                          label_name += `
                               <span class='label label--custom ${tag.replace(' ', '_')}'>
                                ${tag}
                               </span><br/>
                             `;
                        }
                      }
                      new_tag = `
                        <div class='product-item__labels labels'>
                            ${label_name}
                        </div>
                      `;
                    }
                  }
                };
  
                if (_res[_i].includes("_sixdcode")) {
                  let _sixdcode_tag = _res[_i].split('_sixdcode:')[1];
                  if (config_product_sixd.includes(_sixdcode_tag)) {
                    has_config_product_sixd = true;
                  }
                }
                if (_res[_i].includes("_modelcode")) {
                  let _modelcode_tag = _res[_i].split('_modelcode:')[1];
                  if (config_exclusion_based_on_8d.includes(_modelcode_tag)) {
                    has_config_exclusion_based_on_8d = true;
                  }
                }
              }
  
              let has_free_installment_text = label_free_installation;
              if (has_config_product_sixd && !has_config_exclusion_based_on_8d && (free_installment_products.indexOf(item.id) < 0)) {
                list_label += '<span class="label label--custom free_installment_label">' + has_free_installment_text + '</span>';
              }
  
              let sold_out = false, variant_available = false, sold_out_1 = true, no_variant = false;
              let form_add_to_cart = `<form method="post" action="/cart/add" id="product_form_recent_${item.id}" accept-charset="UTF-8" class="product__form" enctype="multipart/form-data">
                                <input type="hidden" name="form_type" value="product">
                                <input type="hidden" name="utf8" value="✓">
                                <input type="hidden" name="quantity" value="1">
                                <input type="hidden" value="${sold_out}">`;
              if (variants) {
                form_add_to_cart += `<input type="hidden" name="variant_available" value="${variant_available}">
                                <input type="hidden" name="no_variant" value="${no_variant}">
                                <input type="hidden" value="${sold_out_1}">`;
                let text_add_to_cart = label_add_to_cart;
                let is_disable_add_to_cart = '';
                variants.map(function (_variant) {
                  /* if any variant has stock, is_out_of_stock = FALSE, otherwise BREAK */
                  if (_variant.inventory_quantity !== 0)
                    is_out_of_stock = false;
                  /*if (_variant.inventory_quantity === 0) {
                    is_out_of_stock = true;
                  }else{
                    if(is_out_of_stock){
                      is_out_of_stock = false;
                    }
                  }*/
                  if (_variant.title != "Default Title" && variant_available == false && _variant.price != 0) {
                    form_add_to_cart += `<input type="hidden" name="id" value="${_variant.id}">
                                      <input type="hidden" name="single-price" data-price="${_variant.price}" value="${Shopify.formatMoney(_variant.price * 100, window.myprice)}">
                                      <input type="hidden" name="single-compare-at-price" data-price="${_variant.compare_at_price}" value="${Shopify.formatMoney(_variant.compare_at_price, window.myprice)}">
                                      <input type="hidden" name="variant_available" value="${variant_available = true}">
                                      <input type="hidden" name="single-option-selector-0" value="${_variant.option1}">
                                      <input type="hidden" name="single-option-selector-1" value="${_variant.option2}">
                                      <input type="hidden" name="single-option-selector-2" value="${_variant.option3}">
                                      <input type="hidden" value="${sold_out_1}">
                                     `;
                  } else {
                    form_add_to_cart += `<div class="price_variant" data-price="${_variant.price}">
                                      <input class="pri" type="hidden" name="${_variant.price}" value="${Shopify.formatMoney(_variant.price * 100, window.myprice)}">`;
                    if (_variant.compare_at_price > _variant.price) {
                      form_add_to_cart += `<input class="pri_c" type="hidden" name="${_variant.compare_at_price}" value="${Shopify.formatMoney(_variant.compare_at_price * 100, window.myprice)}">`;
                    }
                    form_add_to_cart += `</div>`;
                  }
  
                  if (_variant.title == "Default Title") {
                    no_variant = true;
                    form_add_to_cart += `<input type="hidden" name="no_variant" value="${no_variant}">
                                      <input type="hidden" name="id" value="${_variant.id}">`;
                  }
                  available = true;
                })
                if (is_out_of_stock) {
                  text_add_to_cart = label_sold_out;
                  is_disable_add_to_cart = 'disabled="disabled"';
                }
                if (is_pre_order) {
                  text_add_to_cart = label_pre_order;
                }
                if (is_coming_soon) {
                  text_add_to_cart = label_coming_soon;
                  is_disable_add_to_cart = 'disabled="disabled"';
                }
                form_add_to_cart += `<div class="product-item__add-to-cart button-wrapper"><a href="/products/${item.handle}" ${is_disable_add_to_cart} class="product__add-to-cart button button--primary button--orange">${text_add_to_cart}</a></div>`;
  
              }
              form_add_to_cart += `</form>`;
  
  
              html_product += `
                    <div class="grid__cell 1/2 1/3--lap-and-up 1/3--desk">
                      <div class="product-item product-item--push">
                        <figure class="product-item__image-container">
                          <div class="product-item__image-wrapper">
                            <a href="/products/${item.handle}"><div class="aspect-ratio"> <img class="product-item__image image--fade-in lazyloaded" alt="${item.product_type}" src="${image}"></div></a>
                          </div>     
                          ${new_tag}                    
                          ${discount_html}
                        </figure>
                        <div class="product-item__info">
                          <div class="product-item__labels product-item__labels-bellow labels">
                            ${list_label}
                          </div>
                          <h3 class="product-item__title">
                            <a href="/products/${item.handle}" tabindex="-1" aria-hidden="true" alt="${item.product_type}" class="link">${item.title}</a>
                          </h3>
                          <div class="model-product">${_model}</div>
                          <div class="product-content-bottom">
                            <span class="product-item__price product-item__price--new" data-money-convertible="">${Shopify.formatMoney(variant.price * 100, window.myprice)}</span>
                            <div class="tooltip-wrapper">
                              <span class="price-tooltip">1</span>
                              <div class="tooltip-content"><p>1. Giá được đề cập liên quan đến Giá bán lẻ được đề xuất bao gồm VAT và có thể thay đổi theo thời gian mà không cần thông báo trước.</p></div>
                            </div>
                            <span class="product-item__price product-item__price--old" data-money-convertible="">${old_price}</span><br>
                            ${form_add_to_cart}
                          </div>
                        </div>
                        <div class="product-item__see-more button-wrapper ">
                          <a href="/products/${item.handle}" class="button button--primary">Xem chi tiết</a>
                        </div>
                      </div>
                    </div>`;
              
            }

          }
          html_product += `</div></div><section`;
          $(ele).append(html_product);
        }
      }
    }
  })
}(jQuery));
